export const MAX_VENDORS = 25;
